import React from 'react';
import { useDispatch } from 'react-redux';
import { useDroneProvider } from '@src/core/features';
import { useFlightProvider } from '@src/features/order/provider';
import { ArcDroneMarker, setMapCenter } from '@src/core/controllers';
import { useDroneRotations } from '@src/features/drone/hooks/useDroneRotations';
import { isDroneSignalLost } from '@src/features/drone/utils';
import { FlightDroneProps } from './types';

const FlightDrone: React.FC<FlightDroneProps> = (props) => {
  const { drone, isOnMission = false } = props;
  const dispatch = useDispatch();
  const { drones } = useDroneProvider();
  const { flightData, gpsInfo } = useFlightProvider();
  const { rotations } = useDroneRotations(flightData);
  const liveDrone = React.useMemo(
    () =>
      drone?.serialNumber
        ? drones.find((item) => item.serialNumber === drone.serialNumber)
        : undefined,
    [drones, drone?.serialNumber],
  );
  const lost = isDroneSignalLost(liveDrone ?? drone, gpsInfo, flightData?.serialNumber);

  const droneLat = Number(drone?.latitude);
  const droneLng = Number(drone?.longitude);

  const flightLat = Number(flightData?.latitude);
  const flightLng = Number(flightData?.longitude);

  const position = {
    lat: isNaN(flightLat) ? droneLat : flightLat,
    lng: isNaN(flightLng) ? droneLng : flightLng,
  };

  const rotation =
    drone?.serialNumber && typeof rotations[drone.serialNumber] === 'number'
      ? rotations[drone.serialNumber]
      : undefined;

  React.useEffect(() => {
    if (isNaN(droneLat) || isNaN(droneLng)) return;
    dispatch(setMapCenter({ lat: droneLat, lng: droneLng }));
  }, [droneLat, droneLng, dispatch]);

  if (isOnMission) {
    return (
      <ArcDroneMarker.missionArrow
        position={position}
        rotation={rotation}
        lost={lost}
      />
    );
  }

  return <ArcDroneMarker.idleArrow position={position} lost={lost} />;
};

export default FlightDrone;